import { Box, Button, Card, IconBackground } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { largeTabletAndDown } from '@/styles/media'

import { ScrollToTopButtonProps } from './types'

export const DataListContainer = styled(Card).attrs({
  $radii: 'lg',
})`
  padding: ${({ theme }) => `${theme.space[6]} 0`};
  overflow: visible;
  ${largeTabletAndDown(css`
    padding: 0;
    border-radius: 0;
    border: none;
    margin: 0 -${({ theme }) => theme.space[4]};
  `)}
`

export const DataListItemContainer = styled(Box).attrs({
  $display: 'flex',
  $justify: 'space-between',
  $gap: 4,
  $px: 6,
  $py: 2,
})`
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
      &:hover,
      &[data-active='true'] {
        background-color: ${({ theme }) => theme.colors.lightGray};
        & ${IconBackground} {
          background-color: ${({ theme }) => theme.colors.surface};
        }
      }
    `};

  ${largeTabletAndDown(css`
    padding-left: ${({ theme }) => theme.space[4]};
    padding-right: ${({ theme }) => theme.space[4]};
  `)}
`

export const DataListEmptyStateContainer = styled(Box).attrs({ $px: 6 })`
  ${largeTabletAndDown(css`
    padding-left: ${({ theme }) => theme.space[4]};
    padding-right: ${({ theme }) => theme.space[4]};
  `)}
`

export const DataListItemMetaIconContainer = styled(Box).attrs({
  $display: 'flex',
  $gap: 4,
})``

export const DataListItemMetaDataContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $align: 'initial',
  $gap: 1,
})``

export const StyledInfiniteListContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const ScrollToTopButton = styled(Button).attrs({
  variant: 'pillFilled',
  color: 'tertiary',
})<ScrollToTopButtonProps>`
  position: fixed;
  left: calc(50% - ${({ theme }) => theme.space[6]} - var(--sidebar-width) / 2);

  bottom: ${({ theme }) => theme.space[6]};
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  transform: ${({ $show, theme }) =>
    $show
      ? 'translateY(0) translateX(-50%)'
      : `translateY(${theme.space[6]}) translateX(-50%)`};
  transition:
    visibility 0.3s ease,
    opacity 0.3s ease,
    transform 0.3s ease;

  ${largeTabletAndDown(css`
    left: 50%;
  `)}
`
